/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-undef */
// import "@google/model-viewer";
import React, { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  addBandFinalFabricBeforeAtom,
  addToProjectAtom,
  addToProjectImageAtom,
  alankaramDataAtom,
  beforeSelectedImageScaletom,
  currentPillowStateAtom,
  customBandValueAtom,
  fabricAtom,
  loaderAtom,
  modelAtom,
  selectedAllBandAtom,
  selectedBandAtom,
  selectedImageScaletom,
  selectedPartAtom,
  selectedProductAtom,
  uploadImageAtom,
} from "../../state";
import { GET_URL } from "../../constans";
import { ImageGlobalUrl } from "../../lib/constant";
import { v4 as uuidv4 } from "uuid";
import { Storage } from "aws-amplify";
import { SetS3Config } from "../../aws_exports";
import { base64ToBlob } from "../../utils/utils";
import { Spin } from "antd";
import { toast } from "react-toastify";
import DownloadModal from "../modal/DownloadModal";
import { useNavigate } from "react-router-dom";
import ArSectionModal from "./ArModal";
import axios from "axios";
import ARParentalModal from "../modal/ARParentalModal";

const textures = {};

const PillowModelViewer = () => {
  const [modelViewer, setModelViewer] = useState(
    document.querySelector("#model-viewer")
  );
  const fabric = useRecoilValue(fabricAtom);
  const alankaramData = useRecoilValue(alankaramDataAtom);
  const navigate = useNavigate();
  const uploadImage = useRecoilValue(uploadImageAtom);
  const inputValue = useRecoilValue(selectedImageScaletom);
  const inputSetValue = useRecoilValue(beforeSelectedImageScaletom);
  const selectedPart = useRecoilValue(selectedPartAtom);
  const currentPillowState = useRecoilValue(currentPillowStateAtom);
  const [modelAtomValue, setModelAtomValue] = useRecoilState(modelAtom);
  const [addToProject, setAddToProject] = useRecoilState(addToProjectAtom);
  const [addToProjectImage, setAddToProjectImage] = useRecoilState(
    addToProjectImageAtom
  );
  const getCheckSupport = localStorage.getItem("checkSupport");
  const [projectSaveLoading, setProjectSaveLoading] = useState(false);
  const selectedBand = useRecoilValue(selectedBandAtom);
  const selectedAllBand = useRecoilValue(selectedAllBandAtom);
  const addBandFinalFabricBefore = useRecoilValue(addBandFinalFabricBeforeAtom);
  const customBandValue = useRecoilValue(customBandValueAtom);
  const [, setLoader] = useRecoilState(loaderAtom);
  // Query

  const [downloadState, setDownloadState] = useState(false);

  const selectedProduct = useRecoilValue(selectedProductAtom);

  const checkImageDataURL = (imageURL) => {
    const dataRegEx =
      /^\s*data:([a-z]+\/[a-z]+(;[a-z-]+=[a-z-]+)?)?(;base64)?,[a-z0-9!$&',()*.+;=\-._~:@/?%\s]*\s*$/i;
    return !!(
      imageURL &&
      typeof imageURL === "string" &&
      imageURL.match(dataRegEx)
    );
  };

  const checkImageDataBLOB = (imageURL) =>
    !!(imageURL && typeof imageURL === "string" && imageURL.includes("blob:"));

  const updateImageURL = (imageURL) => {
    if (!imageURL || typeof imageURL !== "string") return undefined;

    if (checkImageDataURL(imageURL) || checkImageDataBLOB(imageURL))
      return imageURL;

    if (!imageURL.includes("http")) {
      return `${process.env.NEXT_PUBLIC_CLOUD_FRONT_URL}${imageURL}`;
    }

    return imageURL;
  };
  useEffect(() => {
    const modelViewer = document.querySelector("#model-viewer");
    if (modelViewer) {
      const defaultModelViewerSettings = selectedProduct?.modelViewerSetting
      if (defaultModelViewerSettings?.interpolationDecay) {
        modelViewer.setAttribute('interpolation-decay', defaultModelViewerSettings.interpolationDecay);
      }
      if (defaultModelViewerSettings?.disablePan) {
        modelViewer.setAttribute('disable-pan', defaultModelViewerSettings.disablePan);
      }

      if (defaultModelViewerSettings?.exposure) {
        modelViewer.setAttribute('exposure', defaultModelViewerSettings.exposure);
      }

      if (defaultModelViewerSettings?.maxCameraOrbit) {
        modelViewer.setAttribute('max-camera-orbit', defaultModelViewerSettings.maxCameraOrbit);
      }

      if (defaultModelViewerSettings?.minCameraOrbit) {
        modelViewer.setAttribute('min-camera-orbit', defaultModelViewerSettings.minCameraOrbit);
      }

      if (defaultModelViewerSettings?.selectedToneMapping) {
        modelViewer.setAttribute('tone-mapping', defaultModelViewerSettings.selectedToneMapping);
      }

      if (defaultModelViewerSettings?.cameraOrbit) {
        modelViewer.removeAttribute('camera-orbit');
      }

      if (defaultModelViewerSettings?.cameraTarget) {
        modelViewer.removeAttribute('camera-target');
      }
      if (defaultModelViewerSettings?.disableZoom) {
        modelViewer.setAttribute('disable-zoom', '');
      } else {
        modelViewer.removeAttribute('disable-zoom');
      }

      if (!defaultModelViewerSettings?.disableTap) {
        modelViewer.setAttribute('disable-tab', '');
      } else {
        modelViewer.setAttribute('disable-tab', defaultModelViewerSettings.disableTap);
      }

      if (defaultModelViewerSettings?.shadowIntensity) {
        modelViewer.setAttribute(
          'shadow-intensity',
          defaultModelViewerSettings.shadowIntensity,
        );
      } else {
        modelViewer.setAttribute(
          'shadow-intensity',
          '1',
        );
      }

      const envImg = updateImageURL(defaultModelViewerSettings?.environmentImage);
      if (defaultModelViewerSettings?.environmentImage || envImg) {
        modelViewer.setAttribute('environment-image', envImg || '');
      }

      if (defaultModelViewerSettings?.legacyenvironmentimagebasedlighting) {
        modelViewer.setAttribute(
          'environment-image',
          updateImageURL(
            defaultModelViewerSettings?.style?.envMap ||
            envImg ||
            `${defaultModelViewerSettings?.style?.companyId || ''}/environment/env.jpeg`, // Fallback for companyId
          ) || '' // Ensure a string is passed to updateImageURL
        );
      } else {
        modelViewer.setAttribute('environment-image', '');
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProduct?.modelViewerSetting]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setModelViewer(document.querySelector("#model-viewer"));
    }, 1000);
    setTimeout(() => {
      clearInterval(intervalId);
    }, 1000);
  }, []);

  useEffect(() => {
    updateMaterial();
    (async () => {
      setTimeout(async () => {
        await getUVModel();
      }, 1500);
    })();
  }, [
    fabric?.partWiseFabric,
    modelAtomValue,
    modelViewer,
    selectedBand,
    selectedAllBand,
    addBandFinalFabricBefore,
    customBandValue,
  ]);

  useEffect(() => {
    if (uploadImage) {
      Object.entries(uploadImage).forEach(([key, value]) => {
        createTextureImages(key, value);
      });
    }
  }, [modelAtomValue, modelViewer, uploadImage]);

  const [isArModalOpen, setIsArModalOpen] = useState(false);
  const [qrUrlData, setQrUrlData] = useState();

  const openArModal = () => {
    setIsArModalOpen(true);
  };

  const closeArModal = () => {
    setIsArModalOpen(false);
    setQrUrlData(null);
  };

  const makeid = (length) =>
    Array.from({ length }, () =>
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".charAt(
        Math.floor(Math.random() * 62)
      )
    ).join("");

  const generateQRCodeAndGetURL = (uploadUrl) => {
    const qrcodeElement = document.getElementById("ViewARButton");
    if (!qrcodeElement) {
      console.error("QR code element not found.");
      return null;
    }

    qrcodeElement.innerHTML = "";
    new QRCode(qrcodeElement, {
      text: uploadUrl,
      width: 128,
      height: 128,
      colorDark: "#1c344a",
      colorLight: "#ffffff",
    });

    const canvas = qrcodeElement.querySelector("canvas");
    if (!canvas) {
      console.error("Canvas element not found after generating QR code.");
      return null;
    }
    const qrDataUrl = canvas.toDataURL("image/png");
    return qrDataUrl;
  };

  const handleViewInArButton = async () => {
    SetS3Config();
    const glTF = await modelViewer.exportScene();
    const file = new File([glTF], `${makeid(5)}.glb`);

    try {
      await Storage.put(
        `${alankaramData?.companyId}/glb/${uuidv4()}.glb`,
        file,
        {
          contentType: "model/gltf-binary",
        }
      )
        .then(async (result) => {
          const qrUrl = result?.key;
          const host = window.location.host;
          const qrcodepageurl = `${host}/ar_view/`;
          const fileNameWithoutExtension =
            qrUrl
              ?.split("/")
              .pop()
              ?.replace(/\.glb$/, "") || "";
          console.log(
            "🚀 ~ .then ~ fileNameWithoutExtension:",
            fileNameWithoutExtension
          );
          const qrImageUrl = generateQRCodeAndGetURL(
            `${qrcodepageurl}${fileNameWithoutExtension}`
          );
          if (qrImageUrl) {
            setQrUrlData(qrImageUrl);
          }
        })
        .catch((err) => {
          toast.error(err.message);
        });

      return true;
    } catch (error) {
      console.error("Error exporting the scene:", error);
      return false;
    }
  };

  useEffect(() => {
    (async () => {
      setTimeout(async () => {
        await getUVModel();
        await getImageUVModel();
      }, 1000);
    })();
  }, [modelViewer, uploadImage, inputValue, inputSetValue]);
  const createTextureImages = (imageType, image) => {
    createAndApplyTextureImage("baseColorTexture", image, imageType);
    createAndApplyTextureImage(
      "metallicRoughnessTexture",
      "metalicRoughness.jpeg",
      imageType
    );
    createAndApplyTextureImage("normalTexture", "normal.jpg", imageType);
  };

  const createAndApplyTextureImage = async (channel, path, keys) => {
    if (modelViewer?.model) {
      var texture = await modelViewer.createTexture(path);
      const model = modelViewer.model;
      const parts = model[Object.getOwnPropertySymbols(model)[1]];
      const meterialIndexies = [];
      const partWiseIndex = {};

      parts.forEach((part) => {
        const index = part.initialMaterialIdx;
        if (index || index == 0) {
          partWiseIndex[index] = part.name;
          if (keys?.includes(part.name)) {
            meterialIndexies.push(index);
          }
        }
      });

      meterialIndexies.forEach((index) => {
        const material = modelViewer.model.materials[index];
        if (channel.includes("base") || channel.includes("metallic")) {
          material.pbrMetallicRoughness[channel].setTexture(null);
          material.pbrMetallicRoughness[channel].setTexture(texture);
        } else {
          material[channel]?.setTexture(null);
          material[channel].setTexture(texture);
        }
      });
    }
  };

  const getImageUVModel = async () => {
    try {
      if (modelViewer?.model) {
        const model = modelViewer.model;
        let keys = Object.keys(uploadImage);

        if (!model || !keys?.length) return;

        const parts = model[Object.getOwnPropertySymbols(model)[1]];
        let meterialIndexies = [];

        for (const key of keys) {
          // eslint-disable-next-line no-loop-func
          parts.forEach((part) => {
            if (key === part.name) {
              const index = part.initialMaterialIdx;
              meterialIndexies = {
                ...meterialIndexies,
                [key]: index,
              };
            }
          });
        }
        for (const fabricKey of keys) {
          if (
            typeof meterialIndexies[fabricKey] === "number" &&
            isFinite(meterialIndexies[fabricKey])
          ) {
            const material =
              modelViewer.model.materials[meterialIndexies[fabricKey]];
            const diffuse_map =
              material.pbrMetallicRoughness["baseColorTexture"]?.texture
                ?.sampler;
            const normal_map = material?.normalTexture?.texture?.sampler;
            // const metallic_map = material.pbrMetallicRoughness['metallicRoughnessTexture'].texture.sampler;
            if (selectedPart?.name) {
              const scale = {
                u: inputSetValue?.[selectedPart.name]?.Scale || 1,
                v: inputSetValue?.[selectedPart.name]?.Scale || 1,
              };
              diffuse_map?.setScale(scale);
              normal_map?.setScale(scale);
            }
          }
        }
      }
    } catch (error) {
      console.log(
        "🚀 ~ error file: PillowModelViewer.js:170 ~ getImageUVModel ~ error:",
        error
      );
    }
  };
  const getUVModel = async () => {
    try {
      if (modelViewer?.model) {
        const model = modelViewer.model;
        let keys = [
          ...(fabric.partWiseFabric &&
            Object.keys(fabric.partWiseFabric).length > 0
            ? Object.keys(fabric.partWiseFabric)
            : []),
          ...(uploadImage && Object.keys(uploadImage).length > 0
            ? Object.keys(uploadImage)
            : []),
        ];

        if (!model || !keys?.length) return;
        const parts = model[Object.getOwnPropertySymbols(model)[1]];
        let meterialIndexies = [];

        for (const key of keys) {
          // eslint-disable-next-line no-loop-func
          parts.forEach((part) => {
            if (key === part.name) {
              // const index = part.initialMaterialIdx
              const index = part.initialMaterialIdx;
              meterialIndexies = {
                ...meterialIndexies,
                [key]: index,
              };
            }
          });
        }

        for (const fabricKey of keys) {
          if (
            typeof meterialIndexies[fabricKey] === "number" &&
            isFinite(meterialIndexies[fabricKey])
          ) {
            const material =
              modelViewer.model.materials[meterialIndexies[fabricKey]];
            const diffuse_map =
              material?.pbrMetallicRoughness["baseColorTexture"]?.texture
                ?.sampler;
            const normal_map = material?.normalTexture?.texture?.sampler;
            // const metallic_map = material.pbrMetallicRoughness['metallicRoughnessTexture'].texture.sampler;
            if (selectedPart?.name) {
              const scale = {
                u: inputSetValue?.[selectedPart.name]?.Scale || 1,
                v: inputSetValue?.[selectedPart.name]?.Scale || 1,
              };
              diffuse_map?.setScale(scale);
              normal_map?.setScale(scale);
            }
          }
        }
      }
    } catch (error) {
      console.log(
        "🚀 ~ error file: PillowModelViewer.js:248 ~ getUVModel ~ error:",
        error
      );
    }
    setLoader(false);
  };

  const applyNormalTexure = () => {
    setTimeout(async () => {
      if (window.PIXI) {
        const app = new window.PIXI.Application({
          width: window.innerWidth,
          height: window.innerHeight,
          backgroundColor: 0xaaaaaa,
          view: document.getElementById("renderCanvas"),
        });
        const texture = window.PIXI.Texture.from(addBandFinalFabricBefore);
        const inputSprite = new window.PIXI.Sprite();
        const final_img = addBandFinalFabricBefore;
        var image = new Image();
        image.src = final_img;
        await image.decode();
        const { height: imageHeight, width: imageWidth } = image;
        inputSprite.texture = texture;
        inputSprite.width = imageWidth;
        inputSprite.height = imageHeight;
        app.renderer.resize(imageWidth, imageHeight);

        const canvas = app.view;
        canvas.classList.add("d-none");
        document.body.appendChild(canvas);

        // Create a sprite to display the input image

        app.stage.addChild(inputSprite);

        // Load the fragment shader for normal map generation
        const fragmentShader = `
                precision mediump float;

                varying vec2 vTextureCoord;
                uniform sampler2D uSampler;
                uniform vec2 u_resolution;
                uniform float invertR;
                uniform float invertG;
                uniform float bias;

                void main() {
                    float pixelSize = 1.0 / u_resolution.x;
                    float dx = texture2D(uSampler, vTextureCoord + vec2(pixelSize, 0.0)).r - texture2D(uSampler, vTextureCoord - vec2(pixelSize, 0.0)).r;
                    float dy = texture2D(uSampler, vTextureCoord + vec2(0.0, pixelSize)).r - texture2D(uSampler, vTextureCoord - vec2(0.0, pixelSize)).r;

                    vec3 normal = normalize(vec3(dx * invertR, dy * invertG, 1.0 - (bias / 100.0)));
                    gl_FragColor = vec4(normal * 0.5 + 0.5, 1.0);
                }
          `;

        // Create a new window.PIXI.Filter using the custom fragment shader
        const normalMapFilter = new window.PIXI.Filter(null, fragmentShader);

        // Set the resolution uniform for the filter
        normalMapFilter.uniforms.u_resolution = new Float32Array([
          imageWidth,
          imageHeight,
        ]);
        normalMapFilter.uniforms.invertR = 1;
        normalMapFilter.uniforms.invertG = 1;
        normalMapFilter.uniforms.bias = 50;

        // Apply the filter to the input sprite
        inputSprite.filters = [normalMapFilter];

        // Temporary render texture for blur
        const renderTexture = PIXI.RenderTexture.create({
          width: imageWidth,
          height: imageHeight,
        });

        // Render sprite with blur filter applied
        const blurredSprite = new PIXI.Sprite(renderTexture);
        app.stage.addChild(blurredSprite);

        app.renderer.render(app.stage, undefined, true, null, false);

        const renderPromise = new Promise((resolve) => {
          app.renderer.once("postrender", resolve);
        });
        renderPromise.then(() => {
          // Get the rendered canvas
          const canvas = app.renderer.view;
          const base64URL = canvas.toDataURL("image/jpeg", 0.8);

          setTimeout(() => {
            if (modelViewer?.model) {
              const model = modelViewer.model;
              const parts = model[Object.getOwnPropertySymbols(model)[1]];

              const meterialIndexies = [];
              const partWiseIndex = {};

              parts.forEach((part) => {
                const index = part.initialMaterialIdx;
                partWiseIndex[index] = index;
              });
              meterialIndexies.forEach(async (index) => {
                const material = modelViewer.model.materials[index];
                const createAndApplyTexture1 = async (channel, path) => {
                  var texture = await modelViewer.createTexture(path);
                  material[channel].setTexture(texture);
                };
                createAndApplyTexture1("normalTexture", base64URL);
              });
            }
          }, 100);
        });
      }
    }, 1000);
  };

  const updateMaterial = async () => {
    let keys, material;
    keys = Object.keys(fabric.partWiseFabric);
    material = fabric;

    if (keys.length === 0) {
      // console.log("No fabric keys found");
      return;
    }

    for (const key of keys) {
      if (material.partWiseFabric[key]) {
        let baseKey;
        if (key === "Fringe") {
          baseKey = material.partWiseFabric[key].alphaDiffuse;
        } else {
          baseKey =
            material.partWiseFabric[key].uploadImageUrl ||
            material.partWiseFabric[key].diffuse;
        }
        // console.log(`Applying textures for ${key}:`, {
        //     baseKey,
        //     metallicRoughness: material.partWiseFabric[key].metallicRoughness,
        //     normal: material.partWiseFabric[key].normal
        // });

        await createAndApplyTexture("baseColorTexture", key, baseKey);
        await createAndApplyTexture(
          "metallicRoughnessTexture",
          key,
          material.partWiseFabric[key].metallicRoughness,
          material.partWiseFabric[key]
        );
        await createAndApplyTexture(
          "normalTexture",
          key,
          material.partWiseFabric[key].normal,
          material.partWiseFabric[key]
        );

        if (addBandFinalFabricBefore) {
          if (customBandValue?.show) {
            applyNormalTexure();
          } else {
            if (modelViewer?.model) {
              setTimeout(() => {
                const material = modelViewer.model.materials[0];
                const createAndApplyTexture1 = async (channel, path) => {
                  var texture = await modelViewer.createTexture(path);
                  material[channel].setTexture(texture);
                };
                createAndApplyTexture1("normalTexture", `./normal.jpg`);
              }, 100);
            }
          }
        }
      }
    }
    setLoader(false);
  };

  const createAndApplyTexture = async (
    channel,
    modelPartName,
    fabricImg,
    keyData
  ) => {
    // console.log(`Creating texture for ${modelPartName}, channel: ${channel}`, {
    //     fabricImg,
    //     keyData
    // });

    const base64Image =
      fabricImg?.search("data:image/png;base64") !== -1 ? true : false;
    let imageConvert = fabricImg;
    const keyFullData = keyData;

    if (
      getCheckSupport === "true" &&
      window.webpSupport &&
      !base64Image &&
      fabricImg
    ) {
      imageConvert = fabricImg?.replaceAll(".jpeg", ".webp");
    }

    try {
      if (modelViewer?.model) {
        let texture = null;
        if (fabricImg) {
          if (textures[fabricImg]) {
            texture = textures[fabricImg];
          } else {
            texture = await modelViewer.createTexture(
              base64Image ? fabricImg : `${ImageGlobalUrl}/${imageConvert}`
            );
            textures[fabricImg] = texture;
          }
        }

        const model = modelViewer.model;
        const parts = model[Object.getOwnPropertySymbols(model)[1]];

        const meterialIndexies = [];
        const partWiseIndex = {};

        parts.forEach((part) => {
          const index = part.initialMaterialIdx;
          partWiseIndex[index] = index;
          if (modelPartName === part.name) {
            meterialIndexies.push(index);
          }
        });

        meterialIndexies.forEach(async (index) => {
          const material = modelViewer.model.materials[index];

          if (channel === "metallicRoughnessTexture") {
            material.pbrMetallicRoughness.metallicRoughnessTexture.setTexture(
              null
            );
            if (keyFullData?.matelnessFactor) {
              material.pbrMetallicRoughness.setMetallicFactor(
                keyFullData.matelnessFactor
              );
            }
            if (keyFullData?.roughnessFactor) {
              material.pbrMetallicRoughness.setRoughnessFactor(
                keyFullData.roughnessFactor
              );
            }
          }

          if (channel === "normalTexture" && keyFullData?.normalImageUrl) {
            const imageUrl = GET_URL(keyFullData.normalImageUrl);
            const newTexture = await modelViewer.createTexture(imageUrl);
            if (channel.includes("base") || channel.includes("metallic")) {
              material.pbrMetallicRoughness[channel].setTexture(newTexture);
            } else {
              material[channel].setTexture(newTexture);
            }
          }

          if (fabricImg) {
            if (channel.includes("base") || channel.includes("metallic")) {
              material.pbrMetallicRoughness[channel].setTexture(null);
              material.pbrMetallicRoughness[channel].setTexture(texture);
            } else {
              material[channel]?.setTexture(null);
              material[channel].setTexture(texture);
            }
          } else {
            material[channel]?.setTexture(null);
          }
        });
      }
    } catch (err) {
      console.error("Error in createAndApplyTexture:", err);
    }
  };

  const addToProjectHandler = () => {
    setProjectSaveLoading(true);
    document.querySelector("model-viewer").fieldOfView = 10;
    document.querySelector("#model-viewer").cameraOrbit = "0deg 75deg 90%";
    setTimeout(async () => {
      const FrontImage = document
        .querySelector("#model-viewer")
        .toDataURL("image/png");
      const frontBlob = base64ToBlob(FrontImage, "image/png");
      document.querySelector("#model-viewer").cameraOrbit = "180deg 75deg 90%";
      setTimeout(async () => {
        const backImage = document
          .querySelector("#model-viewer")
          .toDataURL("image/png");
        const backBlob = base64ToBlob(backImage, "image/png");

        const finalName = currentPillowState?.name ?? "Not Found";

        const checkSameName = addToProject?.filter(
          (data) => data?.name === finalName
        );
        const resultDataForDynamicProduct = Object.entries(
          currentPillowState?.partWiseFabric
        ).reduce((acc, [key, value]) => {
          if (value?.name) {
            acc[key] = value.name;
          }
          return acc;
        }, {});
        let checkData;
        if (checkSameName?.length > 0) {
          checkData = addToProject?.findIndex((data) => {
            const existingResult = data?.result || {};
            const newResult = resultDataForDynamicProduct || {};

            const isResultSame =
              JSON.stringify(existingResult) === JSON.stringify(newResult);

            return isResultSame;
          });
        } else {
          checkData = -1;
        }

        if (checkData === -1) {
          // const cehckIndex = addToProject?.filter(data => data?.type === "pillow")?.length
          const cehckIndex = addToProject?.length
            ? Number(addToProject?.[0]?.seriesName?.slice(1))
            : 0;
          let newPaint = {};
          for (let key in fabric?.partWiseFabric) {
            const value = fabric?.partWiseFabric[key];
            newPaint = { ...newPaint, [key]: value?._id };
          }
          const updateFabric = {
            ...fabric,
            partWiseFabric: newPaint,
          };
          let ItemFrontImg;
          let ItemBackImg;

          SetS3Config();

          await Storage.put(
            `${alankaramData?.companyId}/images/${uuidv4()}.png`,
            frontBlob,
            {
              contentType: "image/png",
            }
          )
            .then(async (result) => {
              ItemFrontImg = result?.key;
            })
            .catch((err) => {
              toast.error(err.message);
            });

          await Storage.put(
            `${alankaramData?.companyId}/images/${uuidv4()}.png`,
            backBlob,
            {
              contentType: "image/png",
            }
          )
            .then(async (result) => {
              ItemBackImg = result?.key;
            })
            .catch((err) => {
              toast.error(err.message);
            });
          const resultDataForDynamicProduct = Object.entries(
            currentPillowState?.partWiseFabric
          ).reduce((acc, [key, value]) => {
            if (value?.name) {
              acc[key] = value.name;
            }
            return acc;
          }, {});
          const cleanedData = Object.fromEntries(
            Object.entries(inputSetValue).map(([key, value]) => [
              key,
              { Scale: value.Scale },
            ])
          );

          const addData = {
            modelViewerSetting: selectedProduct?.modelViewerSetting,
            inputSetValue: cleanedData,
            uploadImage,
            name: finalName,
            parts: [],
            type: "pillow",
            quantity: 1,
            base64Image: ItemFrontImg,
            base64ImageBack: ItemBackImg,
            refrenceID: Math.floor(Math.random() * 900) + 100,
            fabric: updateFabric,
            orderStatus: "pending",
            paymentStatus: "pending",
            inputValue,
            createdAt: new Date(),
            modelAtomValue: {
              ...modelAtomValue,
              src:
                document.querySelector("#model-viewer").src ||
                modelAtomValue.src,
            },
            seriesName:
              cehckIndex + 1 > 9 ? `S${cehckIndex + 1}` : `S0${cehckIndex + 1}`,
            result: resultDataForDynamicProduct,
          };

          setAddToProjectImage([FrontImage, ...addToProjectImage]);
          setAddToProject([addData, ...addToProject]);
        } else {
          const updatedData = addToProject?.map((data, index) => {
            if (index === checkData) {
              return {
                ...data,
                quantity: data.quantity + 1,
                parts: data?.parts,
              };
            } else {
              return data;
            }
          });
          setAddToProject(updatedData);
        }
        document.querySelector("#model-viewer").cameraOrbit = "0deg 75deg 105%";
        setLoader(false);
        setProjectSaveLoading(false);
        navigate("/cart");
      }, 1000);
    }, 1000);
  };

  document
    .querySelector("#model-viewer")
    ?.addEventListener("progress", (event) => {
      if (event.detail.totalProgress === 1) {
        setModelAtomValue({
          ...modelAtomValue,
          loading: 100,
        });
        setLoader(false);
      }
    });

  const viewer = document.getElementById('model-viewer');
  // --- Page runtime tracking ---
  const pageStartTime = Date.now();

  // --- Model interaction tracking ---
  let interactionStarted = false;
  let interactionStartTime = null;
  let totalInteractionTime = 0;
  let interactionInterval = null;
  let hasLogged = false;

  function startInteractionTimer() {
    if (!interactionStarted) {
      interactionStarted = true;
      interactionStartTime = Date.now();
      console.log("🔄 Interaction started");
    }

    if (!interactionInterval) {
      interactionInterval = setInterval(() => {
        if (interactionStarted && interactionStartTime) {
          const now = Date.now();
          totalInteractionTime += now - interactionStartTime;
          interactionStartTime = now;

          const interactionSec = Math.round(totalInteractionTime / 1000);
          console.log(`⏱ Model interaction time: ${interactionSec} seconds`);
        }
      }, 1000);
    }
  }

  function stopInteractionTimer() {
    if (interactionStarted && interactionStartTime) {
      totalInteractionTime += Date.now() - interactionStartTime;
      interactionStartTime = null;
      interactionStarted = false;
      console.log("⏹ Interaction stopped");
    }
  }
  if (viewer) {
    // Start/stop tracking
    viewer.addEventListener('mousedown', startInteractionTimer);
    viewer.addEventListener('touchstart', startInteractionTimer);
    viewer.addEventListener('mouseup', stopInteractionTimer);
    viewer.addEventListener('touchend', stopInteractionTimer);
    viewer.addEventListener('mouseleave', stopInteractionTimer);
  }


  // On page unload: log total runtime and interaction time
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden' && !hasLogged) {
      stopInteractionTimer();

      const pageRuntime = Math.round((Date.now() - pageStartTime) / 1000);
      const interactionTime = Math.round(totalInteractionTime / 1000);

      console.log(`🕒 Total page runtime: ${pageRuntime} seconds`);
      console.log(`📤 Final model interaction time: ${interactionTime} seconds`);

      gtag('event', 'User_Page_Spend_Time', {
        event_category: '3D Viewer',
        event_label: 'Total time on page',
        value: pageRuntime
      });

      gtag('event', '3D_Viewer_User_Spend_Time', {
        event_category: '3D Viewer',
        event_label: 'Total interaction time with model',
        value: interactionTime
      });

      hasLogged = true;
    }
  });

  if (modelAtomValue.src) {
    return (
      <>
        <div className="relative">
          <div id="card" className="opacity_class">
            <model-viewer
              tone-mapping="commerce"
              src={modelAtomValue.src}
              camera-controls
              disable-pan
              ar
              id="model-viewer"
              exposure="0.8"
            ></model-viewer>
          </div>
        </div>

        <div className="pillow-model-viewer">
          <button
            className="btn bg-black text-white btn-outline-primary selection_btn"
            onClick={() => addToProjectHandler()}
            disabled={projectSaveLoading}
          >
            Add To Selection
            {projectSaveLoading && (
              <Spin className="new-project-save-submit-loader" />
            )}
          </button>

          <button
            className="btn btn-outline-primary selection_btn"
            disabled={projectSaveLoading}
            onClick={() => setDownloadState(true)}
          >
            Download 3D
          </button>
          <button
            className="ar_button btn btn-outline-primary selection_btn"
            onClick={async () => {
              openArModal();
              await handleViewInArButton();
            }}
          >
            View In AR
          </button>
        </div>

        <div id="ViewARButton" className="hidden" />
        <DownloadModal
          onClose={() => setDownloadState(false)}
          isOpen={downloadState}
          title="DOWNLOAD 3D"
        />

        {isArModalOpen ? (
          <ARParentalModal
            isModalOpen={isArModalOpen}
            closeModal={closeArModal}
            setIsModalOpen={setIsArModalOpen}
            shouldHandleOutsideClick
            darkBackground
            isCentered
            className="arSectionModal"
          >
            <ArSectionModal qrcodeImgPath={qrUrlData ?? ""} />
          </ARParentalModal>
        ) : null}
      </>
    );
  } else {
    return <></>;
  }
};

export default PillowModelViewer;
